import { CircularProgress, Input } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as SearchSmIcon } from "components/Icons/search-sm.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      padding: theme.spacing(6, 4),
      display: "flex",
      alignItems: "center",
      borderBottom: `1px solid ${theme.gray100}`,
      height: "48px",
    },
    input: {
      height: "auto !important",
      marginLeft: theme.spacing(4),
      marginRight: theme.spacing(16),
      position: "relative",
      width: "100%",
    },
    progress: {
      position: "absolute",
      right: theme.spacing(5),
    },
    icon: {
      width: "30px",
      height: "30px",
      color: theme.gray500,
    },
  }),
);

interface Props {
  placeholder?: string;
  searchedValue: string;
  setSearchedValue: (val: string) => void;
  "data-test-id"?: string;
  isLoading?: boolean;
  className?: string;
  progressClassName?: string;
  onInputClick?: () => void;
}

export const Search = ({
  placeholder,
  searchedValue,
  setSearchedValue,
  isLoading,
  "data-test-id": dataTestId,
  className,
  progressClassName,
  onInputClick,
}: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <div className={`${classes.wrapper} ${className ? className : ""}`}>
      <SearchSmIcon className={classes.icon} />
      <Input
        id="search"
        className={classes.input}
        placeholder={placeholder || message({ id: "search" })}
        disableUnderline
        autoComplete="off"
        value={searchedValue}
        onChange={(e) => setSearchedValue(e.target.value)}
        onKeyDown={(e) => {
          e.stopPropagation();

          if (e.key === "ArrowDown") {
            e.preventDefault();
            const list =
              document.querySelector<HTMLElement>("ul[role=listbox]");
            const firstElem = list?.querySelector("li");
            firstElem && firstElem.focus({ preventScroll: true });
          } else {
            onInputClick?.();
          }
        }}
        onClick={onInputClick ? () => onInputClick() : undefined}
        inputProps={{
          "data-test-id": dataTestId ? `${dataTestId}-search` : "",
        }}
        autoFocus
      />
      {isLoading && (
        <CircularProgress
          data-test-id="select-loading"
          className={`${classes.progress} ${
            progressClassName ? progressClassName : ""
          }`}
          size={20}
        />
      )}
    </div>
  );
};
